<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            

            <h4><b>{{ $t('privacyPolicy.dataProcessor.title') }}</b></h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
.terms-footer {
    .btn-cta {
        max-width: 100%;
    }
}

</style>
